import React from "react";

import { Button } from "js/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "js/components/ui/dialog";

interface Props {
  isModalVisible: boolean;
  setIsModalVisible: (visible: boolean) => void;
}

const InfoExpA: React.FC<Props> = ({ isModalVisible, setIsModalVisible }) => {
  return (
    <Dialog open={isModalVisible} onOpenChange={setIsModalVisible}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-slate-800">
            ¡Importante!
          </DialogTitle>
          <DialogDescription className="text-slate-500">
            Estamos mejorando tu experiencia. Tus solicitudes se migraron con
            seguridad a la nueva plataforma.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 text-sm leading-relaxed text-slate-600">
          <p>
            <strong>Las solicitudes de renta anteriores al 28 de noviembre de 2024</strong>{" "}
            fueron adaptadas al nuevo sistema. Toda tu información continúa
            resguardada como siempre.
          </p>
          <p>
            ¿Necesitas acceder a un expediente anterior? Escríbenos por WhatsApp
            y te ayudamos en minutos.
          </p>
        </div>
        <DialogFooter className="pt-4">
          <Button
            variant="outline"
            onClick={() =>
              window.open(
                "https://wa.me/5213333324037?text=Necesito ayuda para acceder a un expediente antiguo",
                "_blank",
              )
            }
          >
            WhatsApp
          </Button>
          <Button onClick={() => setIsModalVisible(false)}>Entendido</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default InfoExpA;
